export default "__VITE_ASSET__CI9w8mCS__"